import { render } from "./PaginationDiv.vue?vue&type=template&id=6b0c7eaf"
import script from "./PaginationDiv.vue?vue&type=script&lang=js"
export * from "./PaginationDiv.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__